module.exports = __webpack_public_path__ + "public/SiteIcons/filterAllDownIcon.svg?bea097d3";